// extracted by mini-css-extract-plugin
module.exports = {"container":"embeddedTable-module--container--3Nyi3"};